<!--
  ~ Copyright (c) 2019 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<div [kitContainer]="model"></div>
